import { Button, CircularProgress } from "@mui/material";
import { ReactNode } from "react";
import { VeBox } from "../../mui";

type Buttons = "contained" | "outlined" | "text";
type ButtonColors = "primary" | "secondary" | "error";
type ButtonTypes = "button" | "submit";

type ButtonSize = "small" | "medium" | "large";

interface ButtonProps {
  children: ReactNode;
  className?: string;
  type?: ButtonTypes;

  disabled?: boolean;
  styles?: React.CSSProperties;
  buttonVariant: Buttons;
  fullWidth?: boolean;
  color?: ButtonColors;
  buttonClick?: any;
  loading?: boolean;
  size?: ButtonSize;
  buttonFullWidth?: any;
  capitaliseText?: boolean;
  buttonMinWidth?: string;
  borderRadius?: string;
}

export function VeButton({
  children,
  className,
  fullWidth,
  styles,
  color = "primary",
  type = "button",
  buttonVariant,
  disabled,
  loading,
  buttonFullWidth,
  size,
  capitaliseText = true,
  buttonClick,
  buttonMinWidth,
  borderRadius,
}: ButtonProps) {
  return (
    <Button
      sx={{
        ...styles,
        textTransform: capitaliseText ? "capitalize" : "none",
        minWidth: buttonFullWidth ? "100%" : buttonMinWidth,
        fontWeight: 500,
        borderRadius: borderRadius,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      disabled={disabled || loading}
      className={className}
      variant={buttonVariant}
      type={type}
      size={size}
      fullWidth={fullWidth}
      color={color}
      onClick={buttonClick}
    >
      {loading ? (
        <VeBox display={"flex"} alignItems={"center"} justifyContent={"center"}>
          <VeBox marginRight={"10px"}>{children}</VeBox>
          <CircularProgress size={15} color="inherit" />
        </VeBox>
      ) : (
        children
      )}
    </Button>
  );
}
